import type { BrandMiniEntity } from '@/features/brand/domain/entities/BrandMiniEntity'
import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { BranchTranslationEntity } from './BranchTranslationEntity'
import type { BranchStatus } from '../enums/BranchStatus'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { BranchContactsEntity } from './BranchPContactsEntity'
import type { OrderFulfillmentMethod } from '@/features/order/domain/enums/OrderFulfillmentMethod'
import type { SalesManEntity } from '@/features/salesMan/domain/entities/SalesManEntity'
import type { InterfaceType } from '../enums/InterfaceType'
import type { BranchMiniEntity } from './BranchMiniEntity'
import type { BranchMinimumCartSystemMiniEntity } from '@/features/branchMinimumCartSystem/domain/entities/BranchMinimumCartSystemMiniEntity'

export class BranchEntity {
  id?: number
  brand?: BrandMiniEntity
  location?: LngLatEntity
  translations?: Array<BranchTranslationEntity> | null
  manualStatus?: BranchStatus
  manualStatusExpiresAt?: string
  service?: ServiceMiniEntity
  createdAt?: string
  disabled?: boolean
  channel?: ChannelMiniEntity
  relatedChannels?: Array<ChannelMiniEntity> | null
  contacts?: Array<BranchContactsEntity> | null
  fulfillmentMethods?: Array<OrderFulfillmentMethod> | null
  saleMan?: SalesManEntity
  interfaceType?: InterfaceType
  minimumCartAmountToOrder?: number | null
  minimumJetOrderAmountToOrder?: number
  skuPrefix?: string | null
  autoOrderApprovalPriceLimit?: number | null
  taxRatioPerOrder?: number | null
  commissionAmountPerOrder?: number | null
  commissionAmountPerJetOrder?: number | null
  mealCommissionAmount?: number | null
  outOfWorkingShift?: boolean
  branchDeliverySystems?: Array<BranchMiniEntity> | null
  minDeliveryTime?: number
  maxDeliveryTime?: number
  zohoBooksVenderId?: string | null
  zohoBooksWarehouseId?: string | null
  hasMyMealSupport?: boolean
  autoAcceptMeals?: boolean
  scheduleOrderApprovalMinutes?: number | null
  allowOperatorItemAdd?: boolean
  allowOperatorItemEdit?: boolean
  allowOperatorItemPriceEdit?: boolean
  isExternal?: boolean
  externalBranchId?: number
  isScheduledOrderSupported?: boolean
  minimumCartSystem?: BranchMinimumCartSystemMiniEntity | null
}
